export const getHash = (path: string) => {
  const match = path.match(/#(.*?)(\?|$)/);
  return match ? match[1] : "";
};
